import React from 'react';

const GeneralButton = ({
  description = 'button',
  url = '/',
  type = 0,
  classes = 'px-4 py-2 m-auto',
  isBlank = false
}) => {
  const target = isBlank ? '_blank' : '';

  switch (type) {
    case 0: // Arrow
      return (
        <a target={target} rel="noopener" className={`flex m-auto w-fit ${classes}`} href={url}>
          <strong className="my-auto mr-2 text-xl italic drop-shadow text-cgBlue-Light">
            {description}
          </strong>
          <iconify-icon className="p-3 text-xl rounded-full drop-shadow text-cgWhite-ContrastTrue bg-cgBlue-Light" icon="tdesign:arrow-right"></iconify-icon>
        </a>
      );
    case 1: // No arrow
      return (
        <a target="_blank" rel="noopener" className={`flex w-fit ${classes}`} href={url}>
          <strong className="my-auto mr-2 text-xl italic drop-shadow text-cgBlue-Light">
            {description}
          </strong>
          <iconify-icon className="hidden p-3 text-xl rounded-full shadow text-cgWhite-ContrastTrue bg-cgBlue-Light" icon="tdesign:arrow-right"></iconify-icon>
        </a>
      );
    case 2: // Rectangle Arrow
      return (
        <a target="_blank" rel="noopener" className={`flex border rounded-sm bg-cgWhite-ContrastTrue border-cgBlue-Light w-fit ${classes}`} href={url}>
          <span className="my-auto mr-2 text-xl italic text-cgBlue-Light">
            {description}
          </span>
          <iconify-icon className="p-1 text-xl rounded-full text-cgBlue-Light" icon="tdesign:arrow-right"></iconify-icon>
        </a>
      );
    case 3:
      return (
        <a target="_blank" rel="noopener" className={`flex rounded-sm w-fit ${classes}`} href={url}>
          <span className="my-auto mr-2 text-xl italic text-cgBlue-Light">
            {description}
          </span>
          <iconify-icon className="p-1 text-xl rounded-full text-cgBlue-Light" icon="tdesign:arrow-right"></iconify-icon>
        </a>
      );
    case 4:
      return (
        <a target="_blank" rel="noopener" className={`flex border rounded bg-cgWhite-ContrastTrue border-cgBlue w-fit ${classes}`} href={url}>
          <strong className="my-auto mr-2 text-xl italic text-cgBlue">
            {description}
          </strong>
          <iconify-icon className="p-1 text-xl rounded-full text-cgBlue" icon="tdesign:arrow-right"></iconify-icon>
        </a>
      );
    case 5: // Arrow white
      return (
        <a target="_blank" rel="noopener" className={`flex m-auto w-fit ${classes}`} href={url}>
          <iconify-icon className="p-3 text-xl border rounded-full drop-shadow border-cgBlue text-cgBlack bg-cgWhite-ContrastTrue" icon="tdesign:arrow-right"></iconify-icon>
          <span className="my-auto ml-4 text-xl italic drop-shadow text-cgBlue">
            {description}
          </span>
        </a>
      );
    default:
      return null;
  }
};

const AgendarCitaButton = ({ type, messageValue }) => {
  const WHATSME_URL = 'https://wa.me/573218114942'
  return (
    <a target="_blank" rel="noopener" className="flex items-center justify-center px-6 py-2 mx-auto rounded-sm w-fit bg-cgBlue-Light drop-shadow-md" href={WHATSME_URL}>
      <strong class="my-auto mr-2 text-xl italic text-cgWhite-ContrastTrue">
        {messageValue}
      </strong>
      <iconify-icon
        class="p-2 text-2xl rounded-full text-cgWhite-ContrastTrue"
        icon="solar:calendar-add-linear"
      ></iconify-icon>
    </a>
  );
};

export { GeneralButton, AgendarCitaButton };
